import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postUserImage = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: '/briefs/uploads/images', data: payload });

  return data;
};

export default postUserImage;
